import { StateService } from "@uirouter/angularjs";
import { IOnInit, IScope } from "angular";
import { IFieldArray } from "AngularFormly";
import { cloneDeep } from "lodash";
import { RecordFileTemplateOptions } from "../../../../../../app/records/forms/formly/types";
import { FormViewController } from "../../../../../../app/records/forms/formView/controller";
//import repeatController from "../../../../../ui-formly/types/repeater/controller";

import {
  FormViewService,
  vsName as FormViewServiceName,
} from "../../../../../../app/records/forms/formView/service";
import fieldHelpers from "../../../../../../app/ui-formly/fieldHelpers";
import {
  FieldConfigurationHelperService,
  vsName as FieldConfigurationHelperServiceName,
} from "../../../../../records/forms/formly/fieldConfigurationHelpers";
import { MachineConfigurationViewGateway } from "../../../models/machineConfiguration";

interface MachineChange {
  MachineId: number;
}

interface MachinesDecommissionFormModel {
  MachineChanges?: MachineChange[];
  Date?: Date;
  Files?: File[];
}

export class MachinesDecommissionViewController implements IOnInit {
  static $inject = [
    FormViewServiceName,
    "$state",
    FieldConfigurationHelperServiceName,
  ];

  formFields!: IFieldArray;
  model!: MachinesDecommissionFormModel;
  machineInfo!: { machineConfigurations: MachineConfigurationViewGateway[] };

  /* start bindings */
  readonly machineConfigurations!: MachineConfigurationViewGateway[];
  /* end binding */

  constructor(
    private readonly formViewService: FormViewService,
    private readonly $state: StateService
  ) {}

  private initializeFormFields(machineInfo: {
    machineConfigurations: MachineConfigurationViewGateway[];
  }) {
    const fileTemplateOptions: RecordFileTemplateOptions = {
      allowMultiple: true,
      label: "Files",
    };

    this.formFields = [
      ...fieldHelpers.columnLayout(
        [
          fieldHelpers.simpleDateField({
            key: "Date",
            name: "Date",
            label: "Project Date",
            required: true,
          }),
          fieldHelpers.simpleStringField({
            key: "ProjectNumber",
            name: "ProjectNumber",
            label: "Project Number",
            required: true,
          }),
        ],
        4
      ),
      fieldHelpers.headerField({
        headerText: "Machines",
        key: "MachinesHeader",
      }),
      {
        key: "machineConfigurations",
        model: machineInfo,
        template: require("!html-loader!../sharedTemplates/machineList.html")
          .default,
      },
      {
        key: "Files",
        name: "Files",
        type: "recordFileUpload",
        templateOptions: fileTemplateOptions,
      },
      fieldHelpers.headerField({ headerText: "Notes", key: "NotesHeader" }),
      fieldHelpers.textAreaField({
        key: "Notes",
        name: "Notes",
        label: " ",
        rows: 5,
      }),
    ];
  }

  $onInit(): void {
    this.model = {
      Date: undefined,
      Files: [],
      MachineChanges: this.machineConfigurations.map((mc) => {
        return { MachineId: mc.MachineId };
      }),
    };
    this.machineInfo = {
      machineConfigurations: cloneDeep(this.machineConfigurations),
    };
    this.initializeFormFields(this.machineInfo);
  }

  getMachineConfigurationView(machineId: number) {
    const machineConfigurationViews = this.machineConfigurations.filter(
      (mc) => mc.MachineId === machineId
    );

    if (machineConfigurationViews.length === 0) return undefined;

    return (
      machineConfigurationViews.find((mc) => mc.CurrentConfiguration) ??
      machineConfigurationViews[0]
    );
  }

  async submit(formViewController: FormViewController): Promise<void> {
    await this.formViewService.submitForm({
      url: `/api/machines/decommission`,
      formObject: {
        ...this.model,
      },
      formViewController,
      method: "post",
    });

    await this.$state.go("^.grid", undefined, { reload: true });
  }

  async cancel(): Promise<void> {
    await this.$state.go("^.grid");
  }
}
